export default "__VITE_ASSET__By1Yt9d6__"